<template>
  <section class="intro">
    <img src="@/assets/images/bg.jpg" alt="" class="intro__bg" />

    <div class="container">
      <div class="intro__desc">
        <h1 class="intro__title">Oral care is self care.</h1>
        <button class="intro__btn">Find your glow</button>
      </div>
    </div>
  </section>

  <section class="about">
    <div class="about__us">
      <h2 class="about__us-title">Hi, we’re Auraglow.</h2>

      <p class="about__us-txt">
        We’re an oral wellness company dedicated to celebrating the unique
        grins, cherishing the quirky expressions, and turning our expertise into
        the thing we love most—authentic smiles.
      </p>
    </div>

    <div class="about__promises">
      <div class="container">
        <h2 class="about__promises-title">Our promises to you</h2>

        <div class="about__promises-cards">
          <div class="about__promises-card">
            <img
              src="@/assets/images/icons/shine.svg"
              alt=""
              class="about__promises-card-img"
            />

            <h3 class="about__promises-card-title">Whiter Smile</h3>

            <p class="about__promises-card-subtitle">
              ​​Our clinically proven teeth whitening formula whitens up to 10
              shades in just 7 days.
            </p>
          </div>
          <div class="about__promises-card">
            <img
              src="@/assets/images/icons/shield.svg"
              alt=""
              class="about__promises-card-img"
            />

            <h3 class="about__promises-card-title">Sensitive Whitening</h3>

            <p class="about__promises-card-subtitle">
              ​​​​A bright smile is one that stays feeling healthy and happy. So
              our whitening products do just that.
            </p>
          </div>
          <div class="about__promises-card">
            <img
              src="@/assets/images/icons/tooth.svg"
              alt=""
              class="about__promises-card-img"
            />

            <h3 class="about__promises-card-title">Enamel Safe</h3>

            <p class="about__promises-card-subtitle">
              ​​​The whitening ingredients we use have two rules. Stains must
              go. Enamel must stay.
            </p>
          </div>
          <div class="about__promises-card">
            <img
              src="@/assets/images/icons/star.svg"
              alt=""
              class="about__promises-card-img"
            />

            <h3 class="about__promises-card-title">Made in America</h3>

            <p class="about__promises-card-subtitle">
              ​​​​​Our dental-grade whitening gel is produced right here in the
              USA.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="products">
    <h2 class="products__title">Our Products</h2>
    <p class="products__txt">Find the right products for your smile</p>

    <div class="container">
      <div class="products__blocks">
        <div class="products__block">
          <div class="products__block-intro">
            <img
              src="@/assets/images/products/product1bg.png"
              alt=""
              class="products__block-intro-img"
            />

            <div class="products__block-intro-main">
              <h3 class="products__block-intro-title">Whitening</h3>

              <button class="products__block-intro-btn">Shop whitening</button>
            </div>
          </div>

          <div class="products__block-desc">
            <div class="products__block-desc-intr">
              <h3 class="products__block-desc-title">
                Complete LED Whitening Kit
              </h3>
              <p class="products__block-desc-price">$80</p>
            </div>

            <img
              src="@/assets/images/products/product1.png"
              alt=""
              class="products__block-desc-img"
            />

            <button class="products__block-desc-btn">Add To Cart</button>
          </div>
        </div>
        <div class="products__block">
          <div class="products__block-intro">
            <img
              src="@/assets/images/products/product2bg.png"
              alt=""
              class="products__block-intro-img"
            />

            <div class="products__block-intro-main">
              <h3 class="products__block-intro-title">Refills & Accessories</h3>

              <button class="products__block-intro-btn">Shop whitening</button>
            </div>
          </div>

          <div class="products__block-desc">
            <div class="products__block-desc-intr">
              <h3 class="products__block-desc-title">Whitening Gel</h3>
              <p class="products__block-desc-price">$45</p>
            </div>

            <img
              src="@/assets/images/products/product2.png"
              alt=""
              class="products__block-desc-img"
            />

            <button class="products__block-desc-btn">Add To Cart</button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="note">
    <Icon />

    <p class="note__txt">
      "You can now multitask while you drive (or sneak away to the bathroom in
      between meetings) with the Auraglow whitening pen. All it takes is 60
      seconds to start seeing a brighter smile."
    </p>
  </section>

  <section class="reviews">
    <h2 class="reviews__title">Customer Reviews</h2>

    <p class="reviews__subtitle">Smiles of all styles love Auraglow</p>

    <img src="@/assets/images/reviews.png" alt="" class="reviews__img" />
  </section>

  <section class="gtee">
    <div class="container">
      <div class="gtee__blocks">
        <div class="gtee__block">
          <img
            src="../../assets/images/block1.png"
            alt=""
            class="gtee__block-img"
          />

          <div class="gtee__block-desc">
            <h3 class="gtee__block-desc-title">Proven to whiten</h3>
            <p class="gtee__block-desc-txt">
              If your dentist uses it, so do we. Every product we make puts
              professional-quality ingredients in your hands, to help you be
              your own version of perfect.
            </p>

            <button class="gtee__block-desc-btn">See the proof</button>
          </div>
        </div>
        <div class="gtee__block">
          <img
            src="../../assets/images/block2.png"
            alt=""
            class="gtee__block-img"
          />

          <div class="gtee__block-desc">
            <h3 class="gtee__block-desc-title">30 days, risk-free</h3>
            <p class="gtee__block-desc-txt">
              Here’s the deal. Come smile with us for a month. See how you feel. If it’s anything short of excellent, you get every penny back. That’s our promise to you. And it’s that simple.
            </p>

            <button class="gtee__block-desc-btn">Our guarantee</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Icon from "@/assets/images/icons/ooo.vue";

export default {
  name: "HomePage",
  components: {
    Icon,
  },
};
</script>
